import blurredEventParticipants from '../public/assets/images/event-card-participants/blurred.png';
import blurredEventParticipants2 from '../public/assets/images/event-card-participants/blurred-2.png';
import blurredEventParticipants3 from '../public/assets/images/event-card-participants/blurred-3.png';
import blurredEventParticipants4 from '../public/assets/images/event-card-participants/blurred-4.png';

export const eventParticipantsPlaceholders = [
	blurredEventParticipants,
	blurredEventParticipants2,
	blurredEventParticipants3,
	blurredEventParticipants4
];
